import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { find, omit } from 'lodash';

const ADD_PAGE = 'ADD_PAGE';
const addPage = page => ({
    type: ADD_PAGE,
    page
});

const reducer = (state = { pages: [] }, action) => {
    switch(action.type) {
        case ADD_PAGE: {
            return Object.assign({}, state, { pages: [...state.pages, action.page] });
        }
        case PAGE_LOADING: {
            return Object.assign({}, state, { loading: true });
        }
        case PAGE_LOADED: {
            const page = find(state.pages, { sitePath: action.url });
            const newPage = Object.assign({}, page, { html: action.data.html });
            return Object.assign({}, state, { pages: [...state.pages.filter(p => p !== page), newPage], loading: false });
        }
        default:
            return state;
    }

    return state;
};

const PAGE_LOADING = 'PAGE_LOADING';
const pageLoadingAction = () => ({
    type: PAGE_LOADING
});

const PAGE_LOADED = 'PAGE_LOADED';
const pageLoadedAction = (url, data) => ({
    type: PAGE_LOADED,
    url,
    data
});

const PAGE_LOAD_ERROR = 'PAGE_LOAD_ERROR';
const pageLoadErrorAction = () => ({
    type: PAGE_LOAD_ERROR
});

export const loadPageContent = (url) => (dispatch, getState) => {
    const state = getState();
    const page = find(state.pages, { sitePath: url });

    if (page.html) {
        return;
    }

    dispatch(pageLoadingAction());

    // const minimumDelay = (delay) => new Promise(resolve => setTimeout(resolve, delay));

    return fetch(`${page.sitePathJson}`)
            .then(r => r.json())
            .then(data => {
                dispatch(pageLoadedAction(url, data));        
            })
            .catch(err => {
                dispatch(pageLoadErrorAction());
            });
};

export default (pages) => {
    const store = createStore(reducer, applyMiddleware(thunk));
    pages.forEach(page => store.dispatch(addPage(page)));
    return store;
};


// WEBPACK FOOTER //
// ./src/store/index.js